import ApiHelper from '../../ApiHelper';
import API_ENDPOINTS from '../../endpoints';

class StudentNotificationHelper {

    async getCourseNotifications(params = {}) {

        try {
            const response = await ApiHelper.get(API_ENDPOINTS.STUDENTS.STUDENT_COURSE_NOTIFICATIONS, params);
            return response;
        } catch (error) {
            throw new Error(`Failed to fetch course notifications: ${error.message}`);
        }
    }


}

export default new StudentNotificationHelper();